import http from './http'

const basePath = '/achievement/otherAchievement'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveOther(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitOther(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function createOther(payload) {
  return payload?.isDraft ? saveOther(payload) : submitOther(payload)
}

export async function updateOther(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  if (typeof body?.isDraft === 'boolean') {
    return body.isDraft ? saveOther(body) : submitOther(body)
  }
  const res = await http.put(basePath, body)
  return res.data
}

export async function getOther(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listOthers(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deleteOther(id) {
  const res = await http.delete(withId(id))
  return res.data
}
